import React, { memo } from 'react';

import PerfectScrollbar from 'react-perfect-scrollbar';

import { numberFormat } from 'utils';
import ChartStockOverview from '../chart/chartStockOverview';

function PanelStockOverView(props) {
  const { stockDetail, symActive, basicInfo, t, stockRealShow } = props;

  // log(stockDetail, basicInfo);

  return (
    <PerfectScrollbar
      className="mt-2"
      style={{ height: 'calc(100vh - 180px)', marginRight: '-12px' }}
    >
      <div className="w-100" style={{ paddingRight: '12px' }}>
        <div className="w-100">
          <ChartStockOverview symActive={symActive} stockRealShow={stockRealShow}/>
        </div>
        <ul className="list-price-overview mt-2">
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-reference-index')}</span>
            <span className="r fz-12 fw-500">{stockDetail?.RefPrice}</span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-Open-Index')}</span>
            <span className="r fz-12 fw-500">{stockDetail?.OpenPrice}</span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-low-high')}</span>
            <span className="txt-content fz-12 fw-500">
              <span className="color-down">{stockDetail?.Lowest}</span> -{' '}
              <span className="color-up">{stockDetail?.Highest}</span>
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-trading-volume')}</span>
            <span className="txt-content fz-12 fw-500">
              {numberFormat(basicInfo?.TotalVolume, 0, '-')}
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-trading-value')}</span>
            <span className="txt-content fz-12 fw-500">
              {numberFormat(basicInfo?.TotalValue / 1000, 2, '0')} {t('algo.bdkt.txt-bil')}
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.ptcp.txt-10-day-avg-vol')}</span>
            <span className="txt-content fz-12 fw-500">
            {numberFormat((basicInfo?.SumVol10d + basicInfo?.TotalVolume) / 10, 0, '0')}
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.ptcp.txt-Market-cap')}</span>
            <span className="txt-content fz-12 fw-500">
              {numberFormat(basicInfo?.MarketCapital)} {t('algo.bdkt.txt-bil')}
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.ptcp.txt-Outstanding-shares')}</span>
            <span className="txt-content fz-12 fw-500">
              {numberFormat(basicInfo?.OutstandingShares)}
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">P/E</span>
            <span className="txt-content fz-12 fw-500">{numberFormat(basicInfo?.PE, 2, '0')}</span>
          </li>
          <li>
            <span className="txt-content fz-12">P/B</span>
            <span className="txt-content fz-12 fw-500">{numberFormat(basicInfo?.PB, 2, '0')}</span>
          </li>
          <li>
            <span className="txt-content fz-12">P/S</span>
            <span className="txt-content fz-12 fw-500">{numberFormat(basicInfo?.PS, 2, '0')}</span>
          </li>
          <li>
            <span className="txt-content fz-12">EPS</span>
            <span className="txt-content fz-12 fw-500">{numberFormat(basicInfo?.EPS, 0, '0')} VNĐ</span>
          </li>
          <li>
            <span className="txt-content fz-12">ROA</span>
            <span className="txt-content fz-12 fw-500">{numberFormat(basicInfo?.ROA, 2, '0')} %</span>
          </li>
          <li>
            <span className="txt-content fz-12">ROE</span>
            <span className="txt-content fz-12 fw-500">{numberFormat(basicInfo?.ROE, 2, '0')} %</span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.ptcp.txt-Sector')}</span>
            <span className="txt-content fz-12 fw-500">
              {basicInfo?.Industry}
            </span>
          </li>
        </ul>
      </div>
    </PerfectScrollbar>
  );
}

export default memo(PanelStockOverView);
